/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Cc_Position_CenterInputs */

const en_shortcut_keys_name_cc_position_center = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position Center`)
};

const fr_shortcut_keys_name_cc_position_center = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Positionner au centre`)
};

const de_shortcut_keys_name_cc_position_center = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Positionszentrum`)
};

const it_shortcut_keys_name_cc_position_center = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizione Centro`)
};

const ru_shortcut_keys_name_cc_position_center = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Центр позиционирования`)
};

const es_shortcut_keys_name_cc_position_center = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro de posición`)
};

const zh_cn2_shortcut_keys_name_cc_position_center = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置中心`)
};

const ja_shortcut_keys_name_cc_position_center = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置中心`)
};

const hi_shortcut_keys_name_cc_position_center = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थिति केंद्र`)
};

const pt_pt2_shortcut_keys_name_cc_position_center = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro de posição`)
};

/**
* | output |
* | --- |
* | "Position Center" |
*
* @param {Shortcut_Keys_Name_Cc_Position_CenterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_cc_position_center = /** @type {((inputs?: Shortcut_Keys_Name_Cc_Position_CenterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Cc_Position_CenterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_cc_position_center(inputs)
	if (locale === "de") return de_shortcut_keys_name_cc_position_center(inputs)
	if (locale === "it") return it_shortcut_keys_name_cc_position_center(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_cc_position_center(inputs)
	if (locale === "es") return es_shortcut_keys_name_cc_position_center(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_cc_position_center(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_cc_position_center(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_cc_position_center(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_cc_position_center(inputs)
	return en_shortcut_keys_name_cc_position_center(inputs)
});